import { useProfileCustomValues } from "PFApp/hooks/use_profile_custom_values";
import { useProfilePreview } from "PFApp/use_profile_preview";
import { ActionDiv, Flex, Inline, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { Profile } from "PFCore/types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const ProfileInfoCell = ({ profile }: { profile: Profile }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "common" });
  const { showPreview } = useProfilePreview();
  const { getJobTitleEntry } = useProfileCustomValues();
  const jobTitle = getJobTitleEntry(profile);

  const onCardClick = useCallback(() => {
    showPreview({ id: profile.id, profile });
  }, [profile, showPreview]);

  return (
    <ActionDiv onClick={onCardClick}>
      <Inline alignItems="center">
        <ProfileAvatar profile={profile} size={32} />
        <Stack gap="spacingXs">
          <Inline gap="spacingXs">
            <Typography variant="bodyButtons">{getProfileName(profile)}</Typography>
            {profile.placeholder && (
              <Tooltip content={t("placeholderProfile")}>
                <Flex center>
                  <Icon name="placeholder-profile" size="sm" />
                </Flex>
              </Tooltip>
            )}
          </Inline>
          {jobTitle && <Typography variant="labelRegular">{jobTitle.value}</Typography>}
        </Stack>
      </Inline>
    </ActionDiv>
  );
};
